import WorkforcegapTable from './WorkforcegapTable';
export default WorkforcegapTable;
